import { format } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";
import { enGB } from "date-fns/locale";
import { ReactNode } from "react";
import { useAppSelector } from "../../../lib/redux/hooks";
import { formatDelay, getDelayColor } from "../../../lib/types";
import Pills from "../../../ui/molecoles/pills";
import { Spinner } from "../../../ui/molecoles/spinner";
import { HeadingComponent } from "../../../ui/organisms/heading";
import { HeadingSize } from "../../../ui/organisms/heading/dto";

export function Departures() {
    const reportState = useAppSelector(state => state.report)

    let departuresList: ReactNode[] = []

    if (reportState.findByIdStatus === "loading") {
        return (
            <div className={"flex justify-center items-center flex-grow"}>
                <Spinner />
            </div>
        )
    }

    if (reportState.findByIdStatus === "successfully" && reportState.findByIdResponse !== undefined && reportState.findByIdResponse.flight_info.departures !== null) {
        const centerIdent = reportState.findByIdResponse?.flight_info.flight.ident_iata;

        const departures = reportState.findByIdResponse.flight_info.departures;

        const center = departures.find(item => item.ident_iata === centerIdent);

        const others = departures.filter(item => item.ident_iata !== centerIdent);

        others.sort((a, b) => new Date(a.scheduled_out).getTime() - new Date(b.scheduled_out).getTime());

        const beforeCount = Math.floor((departures.length - 1) / 2);
        const afterCount = departures.length - 1 - beforeCount;

        const before = others.slice(0, beforeCount);
        const after = others.slice(beforeCount, beforeCount + afterCount);

        const sortedDepartures = [...before, center, ...after];
        sortedDepartures.forEach((item) => {
            if (item !== undefined)
                departuresList.push(
                    <tr
                        className="bg-white h-[56px] border-b-[1px] border-b-neutral-100"
                    >
                        <td
                            className="py-4 px-4 text-text-sm cursor-pointer font-semibold text-neutral-850"
                        >
                            <div className="flex flex-col gap-1 items-center">
                                {new Date(item.scheduled_out).toISOString() === "0001-01-01T00:00:56.000Z"
                                    ? "-"
                                    : formatInTimeZone(item.scheduled_out_tz, item.from_tz, "dd MMM yyyy HH:mm", { locale: enGB })
                                }
                                <Pills
                                    size={"sm"}
                                    label={item.status.diverted ? "Diverted" : item.status.cancelled ? "Canceled" : item.status.blocked ? "Blocked" : "Landed"}
                                    outline={false}
                                    emphasis={false}
                                    color={(item.status.diverted || item.status.cancelled) ? "red" : item.status.blocked ? "orange" : "green"}
                                />
                            </div>
                        </td>
                        <td className="py-4 px-2 text-text-sm font-semibold text-neutral-800">
                            <div className="flex flex-col gap-[2px]">
                                <div className="flex flex-row gap-[4px] items-center">
                                    <span>
                                        {item.ident_iata}
                                    </span>
                                    <span className="text-text-xs font-semibold text-neutral-600">
                                        {item.ident}
                                    </span>
                                </div>
                                {item.operator + " " + item.airline_name}
                                <span className="font-semibold text-neutral-600">
                                    {item.operator + "/" + item.operator_iata}
                                </span>
                            </div>
                        </td>
                        <td className="py-4 px-2 text-text-sm font-semibold text-neutral-800">
                            {item.to.city + " (" + item.to.code_iata + "/" + item.to.code_icao + ")"}
                        </td>
                        <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">
                            {format(item.scheduled_out, "yyyy-MM-dd") === "0001-01-01"
                                ? "-"
                                : formatInTimeZone(item.scheduled_out_tz, item.from_tz, "dd MMM yyyy HH:mm", { locale: enGB }) +
                                " " +
                                item.from_tz_abbr
                            }
                        </td>
                        <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">
                            <div className="flex flex-col gap-1 items-center">
                                {(format(item.actual_out, "yyyy-MM-dd") === "0001-01-01")
                                    ? "-"
                                    : formatInTimeZone(item.actual_out_tz, item.from_tz, "dd MMM yyyy HH:mm", { locale: enGB }) +
                                    " " +
                                    item.from_tz_abbr
                                }
                                {
                                    formatDelay(item.departure_delay) && format(item.actual_out, "yyyy-MM-dd") !== "0001-01-01" ?
                                        <Pills
                                            size={"sm"}
                                            label={formatDelay(item.departure_delay)!}
                                            outline={false}
                                            emphasis={false}
                                            color={getDelayColor(item.departure_delay)}
                                        /> :
                                        format(item.actual_out, "yyyy-MM-dd") !== "0001-01-01" ?
                                            <Pills
                                                size={"sm"}
                                                label={"On time"}
                                                outline={false}
                                                emphasis={false}
                                                color={"green"}
                                            /> : <></>
                                }
                            </div>
                        </td>
                        <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">
                            <div className="flex flex-col gap-1 items-center">
                                {
                                    (format(item.actual_in, "yyyy-MM-dd") === "0001-01-01") ? "-" :
                                        formatInTimeZone(item.actual_in_tz, item.to.timezone, "dd MMM yyyy HH:mm", { locale: enGB }) +
                                        " " +
                                        item.to.timezone_abbr
                                }
                                {
                                    formatDelay(item.arrival_delay) && format(item.actual_in, "yyyy-MM-dd") !== "0001-01-01" ?
                                        <Pills
                                            size={"sm"}
                                            label={formatDelay(item.arrival_delay)!}
                                            outline={false}
                                            emphasis={false}
                                            color={getDelayColor(item.arrival_delay)}
                                        /> : format(item.actual_in, "yyyy-MM-dd") !== "0001-01-01" ?
                                            <Pills
                                                size={"sm"}
                                                label={"On time"}
                                                outline={false}
                                                emphasis={false}
                                                color={"green"}
                                            /> : <></>
                                }
                            </div>
                        </td>
                    </tr>
                )
        })
    }

    return (
        <div className={"flex gap-3 flex-col flex-grow"}>
            <HeadingComponent
                label={reportState.findByIdResponse?.flight_info.flight.departure.airport.city! + " Airport" + " (" + reportState.findByIdResponse?.flight_info.flight.departure.airport.code_iata + ")"}
                buttons={[]}
                size={HeadingSize.SM}
            />
            <div className="w-full flex flex-col gap-4 rounded-tr-xl rounded-tl-xl rounded-b-lg overflow-auto">
                <div>
                    <table className="w-full mb-3">
                        <thead className="h-[56px] bg-neutral-100 font-semibold text-neutral-500 text-text-xs">
                            <tr>
                                <th className="text-left">
                                    <div className="flex py-4 px-4 gap-1 justify-center">
                                        DATE/STATUS
                                    </div>
                                </th>
                                <th className="text-left">
                                    <div className="flex py-4 px-2 gap-1">
                                        FLIGHT
                                    </div>
                                </th>
                                <th className="text-left">
                                    <div className="flex py-4 px-2 gap-1">
                                        DESTINATION
                                    </div>
                                </th>
                                <th className="text-left">
                                    <div className="flex py-4 px-2 gap-1">
                                        SCHEDULED OUT
                                    </div>
                                </th>
                                <th className="text-left">
                                    <div className="flex py-4 px-2 gap-1 justify-center">
                                        ACTUAL OUT
                                    </div>
                                </th>
                                <th className="text-left">
                                    <div className="flex py-4 px-2 gap-1 justify-center">
                                        ACTUAL IN
                                    </div>
                                </th>
                                <th className="text-left">
                                    <div className="flex py-4 px-2 gap-1" />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                reportState.findByIdResponse?.flight_info.departures === null || reportState.findByIdResponse?.flight_info.departures.length === 0 ?
                                    <tr className="bg-white h-[56px] border-b-[1px] border-b-neutral-100">
                                        <td className="py-4 px-4 text-text-sm font-semibold text-neutral-850">No flights available</td>
                                    </tr>
                                    :
                                    departuresList
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}